import { render } from "./3.PartnerRealEstate.vue?vue&type=template&id=57aec30a&scoped=true"
import script from "./3.PartnerRealEstate.vue?vue&type=script&lang=js"
export * from "./3.PartnerRealEstate.vue?vue&type=script&lang=js"

import "./3.PartnerRealEstate.vue?vue&type=style&index=0&id=57aec30a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57aec30a"]])

export default __exports__